<template>
  <div id="app">
     <!-- 路由占位符 -->
         <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: 'app',
  components: {
   
  }
}
</script>
<style lang="less">
    @import url("./assets/iconfont.css");
    .size{
        width: 100%;
        height: 100%;
    }
    html,body{
        .size;
        overflow: hidden;
        margin: 0;
        padding: 0;
        background: url("./assets/images/login-bg.jpg") #f5f7f9 !important;
    }
    #app {
        .size;
        overflow-y: scroll;
    }
    .anjian {
        position: relative;
        display: flex;
        flex: 1;
        align-items: flex-start;
        flex-direction: row;
        padding: 0 10px;
        height: 100%;
    }

    .ivu-table-cell{
        padding-left: 5px !important;
        padding-right: 5px !important;
    }
    .ivu-menu {
        display: flex;
        flex-direction: column;
        justify-content: left;
    }
    .card-left .ivu-menu .ivu-menu-item,.card-left .ivu-menu-vertical .ivu-menu-submenu-title{
        padding-left: 4vh ;
    }
    .card-left .ivu-menu-submenu .ivu-menu-item{
        padding-left: 7vh !important;
        font-size: 14px;
    }
    .card-left {
        background-color: #FFFFFF;
        width: auto;
        min-height: 85vh;
        margin-right: 2vh;
    }
    .ivu-card-body{
        width: 100%;
    }
    .card-left .ivu-card-body{
		
        padding: 0;
    }
    .card-left .ivu-card-bordered{
        border: none;
    }
    .card-right-top {
        position: relative;
        background-color: #FFFFFF;
        width: 100%;
        height: 100%;
        overflow: auto;
        min-width: 1250px !important;
    }

    .card-right-top-bar {
        width: 100%;
        position: relative;
        background-color: #FFFFFF;
    }

    .card-right-bottom {
        width: 100%;
        position: relative;
        background-color: #FFFFFF;
        margin-top: 5px;
    }
    .pager{
        margin-top: 10px;
        text-align: left;
    }
	

    /*::-webkit-scrollbar {*/
    /*    width: 5px;*/
    /*    height: 5px;*/
    /*}*/

    /*::-webkit-scrollbar-track {*/
    /*    --webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);*/
    /*    border-radius: 10px;*/
    /*}*/

    /*::-webkit-scrollbar-thumb {*/
    /*    border-radius: 5px;*/
    /*    background: rgb(93, 136, 185);*/
    /*    --webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.5);*/
    /*}*/

    .ivu-tabs-nav .ivu-tabs-tab:last-child{
        /*margin: 0 8px !important;*/
        margin-right: 0 !important;
    }
</style>

